// GSAP Scroll Animations - Extracted from the website
// Dependencies: GSAP, ScrollTrigger, ScrollSmoother

// Main scroll animation object
const scrollAnimations = {
    // Initialize GSAP plugins
    init() {
        // Register GSAP plugins
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

        // Setup global scroll behavior
        this.setupGlobalScroll();

        // Setup individual animations
        this.setupStarAnimation();
        this.setupProductAnimation();

        // Setup resize handlers
        this.setupResizeHandlers();
    },

    // Setup smooth scrolling
    setupGlobalScroll() {
        const elementsWithSpeed = document.querySelectorAll("[data-speed]");
        const smoothWrapper = document.getElementById("smooth-wrapper");

        if (elementsWithSpeed.length > 0) {
            this.smoother = ScrollSmoother.create({
                smooth: 0.8,
                ignoreMobileResize: true,
                effects: true,
                // normalizeScroll: true
            });
            smoothWrapper.classList.add("is-active");
        } else {
            smoothWrapper.classList.remove("is-active");
            this.smoother = null;
        }
    },
    setupParallaxEffect() {
        const parallaxElements = document.querySelectorAll("[data-speed]");

        ScrollTrigger.create({
            trigger: "body",
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            onUpdate: (self) => {
                parallaxElements.forEach((el) => {
                    const speed = parseFloat(el.dataset.speed) || 1;
                    const yPos = -(
                        self.progress *
                        window.innerHeight *
                        (speed - 1)
                    );
                    gsap.set(el, { y: yPos });
                });
            },
        });
    },
    // Star twinkling animation
    setupStarAnimation() {
        const starContainers = document.querySelectorAll(".js-stars");

        starContainers.forEach((container) => {
            const stars = container.querySelectorAll(".js-stars .star");

            stars.forEach((star) => {
                // Opacity animation
                gsap.to(star, {
                    duration: 1,
                    opacity: 1,
                    stagger: 0.2,
                    repeat: -1,
                    yoyo: true,
                });

                // Scale animation with random delay
                gsap.fromTo(
                    star,
                    {
                        opacity: 0.8,
                        scale: 0.5,
                        transformOrigin: "50% 50%",
                    },
                    {
                        duration: 3.5,
                        delay: Math.random() * 3,
                        opacity: 1,
                        scale: 1,
                        repeat: -1,
                        yoyo: true,
                        stagger: 1,
                    }
                );
            });
        });
    },

    // Product image rotation on scroll
    setupProductAnimation() {
        const productImages = document.querySelectorAll(
            ".js-custom-animation-product-main-image"
        );

        if (productImages.length > 0) {
            productImages.forEach((image) => {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: ".js-custom-animation-product",
                        scrub: 1,
                        start: "top 25%",
                        end: "bottom 75%",
                        markers: false,
                    },
                }).to(image, {
                    stagger: 0.5,
                    rotation: 16,
                    xPercent: -25,
                });
            });
        }
    },

    // Setup resize handlers with throttling
    setupResizeHandlers() {
        const throttledRefresh = this.throttle(() => {
            requestAnimationFrame(() => {
                ScrollTrigger.refresh();
            });
        }, 1000);

        const debouncedRefresh = this.throttle(() => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                ScrollTrigger.refresh();
            }, 250);
        }, 250);

        window.addEventListener("resize", throttledRefresh);
        window.addEventListener("resize", debouncedRefresh);

        // Observer for dynamic content changes
        new ResizeObserver(() => {
            throttledRefresh();
        }).observe(document.body);

        // Refresh after 1 second to ensure everything is loaded
        setTimeout(() => ScrollTrigger.refresh(), 1000);
    },

    // Throttle utility function
    throttle(func, wait) {
        let timeout;
        let previous = 0;

        const later = function () {
            previous = Date.now();
            timeout = null;
            func.apply(this, arguments);
        };

        const throttled = function () {
            const now = Date.now();
            const remaining = wait - (now - previous);

            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                func.apply(this, arguments);
            } else if (!timeout) {
                timeout = setTimeout(later, remaining);
            }
        };

        return throttled;
    },
};

function initSlider() {
    document
        .querySelectorAll(".custom-slider")
        .forEach(function (customSliderSection) {
            let customSlider = customSliderSection.querySelector(
                ".custom-slider-main"
            );
            let prevBtn = customSliderSection.querySelector(
                ".swiper-button-prev"
            );
            let nextBtn = customSliderSection.querySelector(
                ".swiper-button-next"
            );

            // Get data attributes and convert to numbers
            let items = Number(customSlider.getAttribute("data-items"));
            let itemsSm = Number(customSlider.getAttribute("data-items-sm"));
            let itemsMd = Number(customSlider.getAttribute("data-items-md"));
            let itemsLg = Number(customSlider.getAttribute("data-items-lg"));
            let itemsXl = Number(customSlider.getAttribute("data-items-xl"));
            let items2xl = Number(customSlider.getAttribute("data-items-2xl"));
            let items3xl = Number(customSlider.getAttribute("data-items-3xl"));

            // Initialize Swiper
            new Swiper(customSlider, {
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                speed: 700,
                spaceBetween: 24,
                slidesPerGroup: items,
                slidesPerView: items,
                breakpoints: {
                    320: {
                        slidesPerView: items,
                        slidesPerGroup: items,
                    },
                    767: {
                        slidesPerView: itemsMd,
                        slidesPerGroup: itemsMd,
                    },
                    991: {
                        slidesPerView: itemsLg,
                        slidesPerGroup: itemsLg,
                    },
                    1640: {
                        slidesPerView: items3xl,
                        slidesPerGroup: items3xl,
                    },
                },
            });
        });
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
    scrollAnimations.init();
    initSlider();
});

// Also initialize if DOM is already loaded
if (document.readyState === "complete") {
    scrollAnimations.init();
}
